import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { palette } from 'theme';
import { getTopNavStackData } from 'features/navigation/header/actions';
import loadable from '@loadable/component';
import Hidden from '@material-ui/core/Hidden';
import DistributorBar from './elements/DistributorBar';
import { distributorLockedCountries } from 'constants/Countries';
import Cookies from 'js-cookie';

const DesktopNav = loadable(() => import('views/Layout/Header/DesktopNav'));
const MobileNav = loadable(() => import('views/Layout/Header/MobileNav'));
const MinimalNav = loadable(() => import('views/Layout/Header/MinimalNav'));

const NavWrapper = styled.div`
  @media (min-width: 960px) {
    min-height: 42px;
    background: ${palette.grey[900]};
  }
`;

const Header = ({ getTopNavStackData, minimal, hidden }) => {
  useEffect(() => {
    getTopNavStackData();
  }, [getTopNavStackData]);

  if (hidden) return null;

  if (minimal) return <MinimalNav />;

  return (
    <NavWrapper>
      {distributorLockedCountries.includes(Cookies.get('ip_country')) && (
        <DistributorBar />
      )}
      <Hidden smDown>
        <DesktopNav />
      </Hidden>
      <Hidden mdUp>
        <MobileNav />
      </Hidden>
    </NavWrapper>
  );
};

export default connect(
  state => ({
    minimal: state.navigation.minimal,
    hidden: state.navigation.hidden,
    loading: state.navigation.loading
  }),
  { getTopNavStackData }
)(Header);
